const militaryBranches = [
  {
    label: 'Army',
    logo: 'https://public.readdy.ai/ai/img_res/1c7d08b19ee1ab9f61adf35b97d83dbc.jpg',
  },
  {
    label: 'Navy',
    logo: 'https://readdy.ai/api/search-image?query=United%20States%20Navy%20official%20seal%20emblem%20circular%20crest%20gold%20dark%20blue%20anchor%20eagle%20on%20clean%20white%20background%20military%20insignia%20sharp%20professional%20heraldry&width=120&height=120&seq=navy-seal-logo-v3&orientation=squarish',
  },
  {
    label: 'Air Force',
    logo: 'https://readdy.ai/api/search-image?query=United%20States%20Air%20Force%20official%20seal%20emblem%20circular%20crest%20blue%20gold%20wings%20eagle%20on%20clean%20white%20background%20military%20insignia%20sharp%20professional%20heraldry&width=120&height=120&seq=airforce-seal-logo-v3&orientation=squarish',
  },
  {
    label: 'Marines',
    logo: 'https://readdy.ai/api/search-image?query=United%20States%20Marine%20Corps%20official%20seal%20emblem%20circular%20crest%20red%20gold%20eagle%20globe%20anchor%20on%20clean%20white%20background%20military%20insignia%20sharp%20professional%20heraldry&width=120&height=120&seq=marines-seal-logo-v3&orientation=squarish',
  },
  {
    label: 'Coast Guard',
    logo: 'https://readdy.ai/api/search-image?query=United%20States%20Coast%20Guard%20official%20seal%20emblem%20circular%20crest%20blue%20gold%20shield%20anchor%20on%20clean%20white%20background%20military%20insignia%20sharp%20professional%20heraldry&width=120&height=120&seq=coastguard-seal-logo-v3&orientation=squarish',
  },
  {
    label: 'Space Force',
    logo: 'https://readdy.ai/api/search-image?query=United%20States%20Space%20Force%20official%20seal%20emblem%20circular%20crest%20dark%20blue%20silver%20delta%20star%20orbit%20on%20clean%20white%20background%20military%20insignia%20sharp%20professional%20heraldry&width=120&height=120&seq=spaceforce-seal-logo-v3&orientation=squarish',
  },
];

const firstResponders = [
  {
    label: 'Police',
    logo: 'https://readdy.ai/api/search-image?query=police%20department%20official%20badge%20shield%20emblem%20gold%20silver%20blue%20circular%20crest%20law%20enforcement%20on%20clean%20white%20background%20sharp%20professional%20insignia&width=120&height=120&seq=police-badge-logo-v3&orientation=squarish',
  },
  {
    label: 'Fire & Rescue',
    logo: 'https://readdy.ai/api/search-image?query=fire%20department%20official%20seal%20emblem%20circular%20crest%20red%20gold%20Maltese%20cross%20firefighter%20on%20clean%20white%20background%20sharp%20professional%20insignia%20heraldry&width=120&height=120&seq=fire-seal-logo-v3&orientation=squarish',
  },
  {
    label: 'EMT / Paramedic',
    logo: 'https://readdy.ai/api/search-image?query=EMT%20paramedic%20EMS%20official%20seal%20emblem%20circular%20crest%20blue%20white%20Star%20of%20Life%20medical%20emergency%20services%20on%20clean%20white%20background%20sharp%20professional%20insignia&width=120&height=120&seq=emt-seal-logo-v3&orientation=squarish',
  },
  {
    label: '911 Dispatch',
    logo: 'https://readdy.ai/api/search-image?query=911%20emergency%20dispatch%20communications%20official%20seal%20emblem%20circular%20crest%20blue%20gold%20radio%20tower%20on%20clean%20white%20background%20sharp%20professional%20insignia%20heraldry&width=120&height=120&seq=dispatch-seal-logo-v3&orientation=squarish',
  },
];

export default function MilitaryHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=large%20dramatic%20American%20flag%20waving%20proudly%20in%20bright%20blue%20sky%20with%20sunlight%20shining%20through%20vivid%20red%20white%20and%20blue%20colors%20bold%20patriotic%20powerful%20cinematic%20photography%20high%20contrast%20sharp%20details%20stars%20and%20stripes%20filling%20the%20entire%20frame&width=1920&height=900&seq=mil-flag-hero-v9&orientation=landscape"
          alt="American flag background"
          className="w-full h-full object-cover object-center"
          fetchPriority="high"
          decoding="async"
          width={1920}
          height={900}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/80 via-slate-900/70 to-red-950/75"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-6">
            <i className="ri-medal-fill text-yellow-400"></i>
            <span className="text-sm font-semibold tracking-wide">Dog Tag Discount</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            No DD-214 Required.
            <br />
            <span className="text-yellow-400">Just Thank You.</span>
          </h1>

          <p className="text-xl sm:text-2xl text-slate-300 mb-4 leading-relaxed">
            Military, veterans, and first responders get{' '}
            <strong className="text-white">$300 off any vehicle</strong> — or donate it to Oregon Dog Rescue.
          </p>

          <p className="text-lg text-slate-400 mb-10">
            Dealerships demand paperwork to protect their profit. We take your word for it — because we
            just want to thank you for your service.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
            <a
              href="#inquiry-form"
              className="inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-medal-fill"></i>
              Claim Your $300
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="/inventory"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold transition-all border border-white/20 whitespace-nowrap"
            >
              Browse Inventory
              <i className="ri-car-line"></i>
            </a>
          </div>

          {/* Military Branches */}
          <div className="border-t border-white/10 pt-8 mb-8">
            <p className="text-xs text-slate-500 uppercase tracking-widest mb-6 font-semibold">Honoring All Who Serve</p>
            <div className="flex flex-wrap justify-center gap-6">
              {militaryBranches.map((b) => (
                <div key={b.label} className="flex flex-col items-center gap-2 group">
                  <div className="w-14 h-14 rounded-full overflow-hidden bg-white/10 border border-white/20 flex items-center justify-center flex-shrink-0 group-hover:border-yellow-400/60 transition-colors">
                    <img
                      src={b.logo}
                      alt={`${b.label} seal`}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      width={56}
                      height={56}
                    />
                  </div>
                  <span className="text-xs font-semibold text-slate-300 tracking-wide">{b.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* First Responders */}
          <div className="border-t border-white/10 pt-8">
            <p className="text-xs text-slate-500 uppercase tracking-widest mb-6 font-semibold">
              <i className="ri-shield-star-fill text-red-400 mr-1"></i>
              Also Honoring First Responders
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              {firstResponders.map((r) => (
                <div key={r.label} className="flex flex-col items-center gap-2 group">
                  <div className="w-14 h-14 rounded-full overflow-hidden bg-white/10 border border-white/20 flex items-center justify-center flex-shrink-0 group-hover:border-red-400/60 transition-colors">
                    <img
                      src={r.logo}
                      alt={`${r.label} badge`}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      width={56}
                      height={56}
                    />
                  </div>
                  <span className="text-xs font-semibold text-slate-300 tracking-wide">{r.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
